











import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import 'vue-select/dist/vue-select.css';
import VueApexCharts from 'vue-apexcharts';

@Component({
  components: { apexchart: VueApexCharts },
})
export default class GoalAchievementChart extends Vue {
  @Prop()
  value!: number;

  @Prop()
  title!: string;

  mounted() {
    this.series = [this.value];
  }

  @Watch('value')
  onValueChange() {
    this.series = [this.value];
    let color: string;

    if (this.value >= 100) {
      color = '#28C76F';
    } else if (this.value > 80) {
      color = '#a7eea5';
    } else if (this.value > 55) {
      color = '#dbec66';
    } else if (this.value > 25) {
      color = '#ffd856';
    } else if (this.value > 15) {
      color = '#eea872';
    } else {
      color = '#e95556';
    }

    this.chartOptions = {
      ...this.chartOptions,
      colors: [color],
    };
  }

  series = [70];
  chartOptions = {
    grid: {
      padding: {
        top: -12,
        bottom: -12,
      },
    },
    chart: {
      type: 'radialBar',
    },
    colors: ['#28C76F'],
    plotOptions: {
      radialBar: {
        hollow: {
          size: '43%',
        },
        dataLabels: {
          show: true,
          value: {
            show: true,
            fontSize: '12px',
            offsetY: 5,
          },
          name: {
            show: false,
          },
        },
        legend: {
          show: false,
        },
      },
    },
  };
}
